module.exports = __webpack_public_path__ + "static/media/Sophie Himsworth Alcove Units (5).83826b47.jpg";